import api from "../../utils/api";

export const getAllExplore = async () => {
  return (await api.get("/Utilities/Utilities/GetAllExplore"))
    ?.data as ExploreResponse;
};
